module.exports = __webpack_public_path__ + "img/85.4ebf3300.png";